/* eslint-disable @typescript-eslint/naming-convention */
import { IProcessCartHeaderLottieData } from "./types";

export enum LottieOverlayId {
    CART_HEADER_LOTTIE = "CART_HEADER_LOTTIE",
}

export enum LottieCartType {
    _99STORE = "99STORE",
    BOLT = "BOLT",
    EXPRESS = "EXPRESS",
    BLACKOTG = "BLACKOTG",
    TOING = "TOING",
    EO_CART = "EO_CART",
}

export const LOTTIE_LOCAL_STORAGE_KEY_PREFIX = "cart_header_lottie";

export const MAGIC_ITEMS_LOTTIE_STORAGE_KEY = "CROSS_SELL_MAGIC_DEALS_OVERLAY_LOTTIE";

export const EmptyProcessCartData: IProcessCartHeaderLottieData = {
    cartType: "",
    lottieArray: [],
    hasLottie: false,
    isFrequencyCapEnabled: false,
    rxId: "",
    sid: "",
    isOtg: false,
    sessionFreqCapKey: "",
    lottieLocalStorageKey: "",
    lottieFrequencyDataObject: {},
    frequencyCapData: {
        id: "",
        count: 0,
        session_count: 0,
    },
    delayData: {
        value: 0,
        unit: "",
    },
    skipAnimationShowFinalState: false,
};
